var Scroll;
(function (Scroll) {
  Scroll["CONTENT"] = "content";
  Scroll["VIEWPORT"] = "viewport";
})(Scroll || (Scroll = {}));

export { Scroll };
//# sourceMappingURL=scroll.mjs.map
